export default {
  title: 'فرم روش پرداخت',
  detail:'ایجاد و ویرایش  روش پرداخت',
  nameFa : 'عنوان فارسی',
  nameEn : 'عنوان لاتین',
  discountPercent:'درصد تخفیف',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  back : 'لغو',
  success : 'موفق',
  error : 'خطا',
  save : 'ذخیره',
  loading : 'در حال بارگزاری',
  saving : 'در حال بارگزاری ...',
  placeholderNameFa:'عنوان فارسی را وارد نماید',
  placeholderNameEn:'عنوان لاتین را وارد نماید',
  placeholderDiscountPercent:'درصد تخفیف'


}
